import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';

import { GatewayReportComponent } from './gateway-report.component';
import { GatewayReportService } from './gateway-report.service';

@NgModule({
  declarations: [
    GatewayReportComponent
  ],
  imports: [
    CommonModule,
    HttpModule
  ],
  providers: [GatewayReportService],
  bootstrap: [GatewayReportComponent],
})

export class GatewayReportModule { }



// WEBPACK FOOTER //
// /Users/sensorflow/Documents/legacy/kalinda/Dashboard/sensorflow-dashboard/src/app/gateway-status/reports/gateway-report.module.ts